import type { ListingViewModel } from 'api/types/listings/ListingViewModel';
import {
  ListingContactMethod,
  type ListingContactMethodValue,
} from 'constants/listingContactMethod';

export function resolveContactMethodsFromListing(
  listing: Pick<ListingViewModel, 'contactMethods' | 'showPhoneOnListing'>
): ListingContactMethodValue[] {
  const fromApi = (listing.contactMethods ?? []).filter(Boolean) as ListingContactMethodValue[];
  if (fromApi.length > 0) return fromApi;
  if (listing.showPhoneOnListing) {
    return [ListingContactMethod.Phone, ListingContactMethod.DirectMessage];
  }
  return [ListingContactMethod.DirectMessage];
}
